import { IModelBase } from "@pmis3/utils";
import { IOrganization, IVessel } from "@pmis3/master-data-core";
import { IVesselActivity } from "./vessel-activity"
import { ILocation } from "@pmis3/master-data-core";
import { IVesselVisitOrganization } from "@pmis3/master-data-core";
import { ISeaport } from "@pmis3/ui-features";

export interface IVesselVisit extends IVesselVisitGridItem {
    vesselId?: number;
    vessel?: IVessel;
    organizations?: IVesselVisitOrganization[]

    startTime?: Date;
    estimatedEndTime?: Date;
    endTime?: Date;
    voyageNumber?: string;
    nextPortOfCallId?: number;
    nextPortOfCall?: ISeaport;
    statusId?: number;
    status?: IVesselTransitStatus;
    lastPortOfCallId?: number;
    lastPortOfCall?: ISeaport;
    remarks?: string;
    hasNTAParticipationDeclaration?: boolean;

	pilotStationETA?: Date;
    pilotStationETD?: Date;
    
    // These fields are duplicates and may be deleted in the future
    berthETA?: Date;
    pilotBoardingETA?: Date;
	pilotBoardingATA?: Date;

    agentName?: string;
	agent247ContactPhone?: string;
	agent247ContactEmail?: string;
	vesselMasterName?: string;
	vesselContactEmail?: string;
	vesselContactPhone?: string;

    isAdded?: boolean;
    isDeleted?: boolean;
}

export interface IVesselVisitGridItem extends IModelBase {
    id: number;
    vesselName?: string;
    vesselTypeId?: number;
    vesselTypeName?: string;
    loa?: number;
    imo?: string;
    marineAgencyId?: number;
    marineAgencyName?: string;
    statusName?: string;
    lastPortOfCallName?: string;
    nextPortOfCallName?: string;
    vesselActivities?: IVesselActivity[];
}

export enum VesselTransitStatus {
    New = "New",
    Draft = "Draft",
    Rejected = "Rejected",
    Approved = "Approved",
    Pending = "Pending",
    Completed = "Completed",
    Cancelled = "Cancelled",
    InProgress = "In Progress"
}

export enum VesselTransitStatusId {
    Draft = 268,
    Pending = 269,
    Approved = 270,
    NotApproved = 271,
    Withdrawn = 272,
    Cancelled = 273,
    Completed = 274,
}

export interface IVesselTransitStatus {
    id: number;
    name: string;
}

export enum VesselServiceRequest {
    Anchorage = "Anchorage", 
    ScrubberDeclaration = "Scrubber Declaration", 
    HotWork = "Hot Work", 
    Lifeboat = "Lifeboat", 
    Bunkering = "Bunkering", 
    Diving = "Diving", 
    EngineImmobilization = "Engine Immobilization"
}